package nl.volleyplanner.api.volleyanalyzer

import kotlinx.serialization.Serializable
import nl.volleyplanner.api.sports.BasicPoule
import nl.volleyplanner.api.sports.FullPoule
import nl.volleyplanner.api.sports.Match

@Serializable
data class PouleListItem(
    val fullPoule: FullPoule,
    val teams: List<String>
)

@Serializable
data class PouleListResponse(
    val items: List<PouleListItem>
)

@Serializable
data class PouleTeam(
    val name: String,
    val poules: List<BasicPoule>
)

@Serializable
data class PouleMatchesResponse(
    val fullPoule: FullPoule,
    val teams: Map<String, PouleTeam>,
    val matches: List<Match>
)

@Serializable
data class MultiPouleMatchesResponse(
    val pouleMatches: Map<String, PouleMatchesResponse>
)
